import React from "react";
import BASE_LAYOUT from "../layout/BaseLayout.component";
import PageStyles from "./Page.styles";
import { useHistory } from "react-router-dom";
import { IErrorPageProps } from "./Page.types";

const ERROR_PAGE: React.FC<IErrorPageProps> = ({ error }) => {
  const history = useHistory();

  function handleClick(path: string) {
    history.push(path);
  }

  return (
    <>
      <BASE_LAYOUT>
        <PageStyles.ErrorRow
          className="error-row justify-content-center"
          data-testid="error-page"
        >
          <PageStyles.ErrorColumn className="error-column">
            {error.icon && (
              <PageStyles.ErrorIcon
                data-testid="error-icon"
                className="error-icon"
                src={error.icon}
              />
            )}
            <PageStyles.ErrorMainText data-testid="error-main-text">
              {error.title}
            </PageStyles.ErrorMainText>
            <PageStyles.ErrorSubText data-testid="error-sub-text">
              {error.detailedMessage}
            </PageStyles.ErrorSubText>

            <PageStyles.ErrorButton
              className="no-scale"
              testid="error-button"
              onClick={() => handleClick("/")}
            >
              Home
            </PageStyles.ErrorButton>
          </PageStyles.ErrorColumn>
        </PageStyles.ErrorRow>
      </BASE_LAYOUT>
    </>
  );
};

export default ERROR_PAGE;
